module.exports = __webpack_public_path__ + "img/adviser-b.64011258.svg";